// Geteilte Tastatur-Helfer für GLOBALE keydown-Handler (Editor-Hotkeys D78,
// Type-to-search D123). Bewusst winzig und DOM-nah — keine React-Abhängigkeit.

/**
 * True, wenn das Element gerade TEXTEINGABE entgegennimmt (INPUT/TEXTAREA/SELECT/
 * contentEditable — letzteres deckt auch eingebettete Editor-Widgets wie Blocklys
 * Feld-Editor ab). Globale Hotkey-/Type-to-search-Handler müssen dann passiv bleiben,
 * sonst kapern sie die Eingabe des Users (D123; zuvor inline im Editor-Viewport).
 */
export function isTextEntryTarget(el: Element | null): boolean {
  return (
    el instanceof HTMLElement &&
    (el.tagName === "INPUT" || el.tagName === "TEXTAREA" || el.tagName === "SELECT" || el.isContentEditable)
  );
}
